import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { getTranslation } from '../common';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import ViewListIcon from '@mui/icons-material/ViewList';
import { Translations } from '../model/messageModel';
import FlowentiButton from './flowenti-ui-kit/FlowentiButton';

interface MyActivitiesCardsViewModeProps {
  view: 'minimal' | 'compact' | 'extended';
  handleViewChange: (newView: 'minimal' | 'compact' | 'extended') => void;
  translations: Translations;
}

const MyActivitiesCardsViewMode: React.FC<MyActivitiesCardsViewModeProps> = ({
  view,
  handleViewChange,
  translations,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (newView: 'minimal' | 'compact' | 'extended') => {
    handleViewChange(newView);
    handleClose();
  };

  const getIconForView = (currentView: 'minimal' | 'compact' | 'extended') => {
    switch (currentView) {
      case 'minimal':
        return <ViewCompactIcon color='primary' />;
      case 'compact':
        return <ViewListIcon color='primary' />;
      case 'extended':
        return <ViewComfyIcon color='primary' />;
      default:
        return <ViewListIcon color='primary' />;
    }
  };

  return (
    <>
      <Tooltip title={getTranslation(translations, "generic.view_mode")}>
        <FlowentiButton
          id="view-mode-button"
          aria-controls={open ? 'view-mode-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          variant="outlined"
          size="small"
          endIcon={getIconForView(view)}
        >
          {getTranslation(translations, `generic.view.${view}`)}
        </FlowentiButton>
      </Tooltip>
      <Menu
        id="view-mode-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'view-mode-button',
        }}
      >
        <MenuItem onClick={() => handleMenuItemClick('minimal')}>
          {getTranslation(translations, "generic.view.minimal")}
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('compact')}>
          {getTranslation(translations, "generic.view.compact")}
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('extended')}>
          {getTranslation(translations, "generic.view.extended")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MyActivitiesCardsViewMode;
